/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionconfirmnone2Inputs */

const en_actionconfirmnone2 = /** @type {(inputs: Actionconfirmnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody has this place as a favourite yet. One action per day.`)
};

const de_actionconfirmnone2 = /** @type {(inputs: Actionconfirmnone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch hat niemand den Ort als Favorit. Pro Tag geht eine Aktion.`)
};

/**
* | output |
* | --- |
* | "Nobody has this place as a favourite yet. One action per day." |
*
* @param {Actionconfirmnone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionconfirmnone2 = /** @type {((inputs?: Actionconfirmnone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionconfirmnone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionconfirmnone2(inputs)
	return de_actionconfirmnone2(inputs)
});
export { actionconfirmnone2 as "actionConfirmNone" }